import { Component, OnInit, } from '@angular/core';
import { TranslateService } from "@ngx-translate/core";
import { SiteSettingFacade } from "../../services/index";
import { BaseComponent } from "../../base/base-component.component";
import { DefaultContents } from "../../models/app-token";
import { PagesComponent } from '../../pages/pages/pages.component';
import { PageComponent } from '../../pages/page/page.component';
import { AdvancedPageComponent } from '../../pages/advanced-page/advanced-page.component';

@Component({
  selector: 'private',
  templateUrl: './private.component.html'
})
export class PrivateComponent extends BaseComponent implements OnInit {

  isPages: boolean = false;

  constructor(
    private readonly siteSettingFacade: SiteSettingFacade,
    translateService: TranslateService) {
    super(translateService);
  }

  ngOnInit(): void { }



  //https://stackoverflow.com/questions/41451375/passing-data-into-router-outlet-child-components/
  //TODO handle caveat
  onOutletLoaded(component) {
    component.siteSetting = this.siteSetting;
    if (component instanceof PagesComponent
      || component instanceof PageComponent
      || component instanceof AdvancedPageComponent) {
      this.isPages = true;
    } else {
      this.isPages = false;
    }
    if (!component.siteSetting) {
      this.siteSetting = this.siteSettingFacade.getByCode(DefaultContents.DEFAULT_SITE_SETTING_CODE);
      component.siteSetting = this.siteSetting;
    }
  }
}
